import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { VideolessonsApi } from '../../api/api/VideolessonsApi';
import { Category } from '../../api/model/Category';
import { Lesson } from '../../api/model/Lesson';
import { DomSanitizer } from '@angular/platform-browser';
import { trigger, state, style, animate, transition } from '@angular/animations';

interface Active {
  category: Category;
  lesson: Lesson;
}

@Component({
  selector: 'app-lessons',
  templateUrl: './lessons.component.html',
  styleUrls: ['./lessons.component.css'],
  animations: [
    trigger('toggle', [
      state('show', style({height: '*', opacity: 1})),
      state('hide', style({height: 0, opacity: 0})),
      transition('* => *', animate('.2s'))
    ])
  ]
})
export class LessonsComponent implements OnInit, OnChanges {

	@Input() isOpen: boolean;
  public categories;
  public active: Active = {
    category: null,
    lesson: null
  };
  public url;

  constructor(
    private appApi: VideolessonsApi,
    private sanitizer: DomSanitizer
  ) {}

  public choose(lesson, category) {
	let lessonCode;
    this.active.lesson = lesson;
    this.active.category = category;
	if ( !this.active.category ) {
		lessonCode = 'BGGSx4iG-EI';
	} else {
		lessonCode = this.active.lesson.code;
	}
    this.url = this.sanitizer
      .bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${lessonCode}?rel=0&amp;controls=1&amp;showinfo=0`);
  }

  public openState(isOpen) {
    return isOpen ? 'show' : 'hide';
  }

	public onComponentClose() {
		this.choose(this.active.lesson, this.active.category);
	}

	private filterCats ( cat ) {
		if ( typeof cat.lesson_set === 'undefined' || cat.lesson_set.length < 1 ) {
			return false;
		}
		return true;
	}

  ngOnInit() {
    this.appApi.getVideoLessons().subscribe(res => {
		this.categories = res.filter( this.filterCats );
		if ( this.categories.length > 0 ) {
			this.categories[0].open = true;
			this.active.category = this.categories[0];
			this.active.lesson = this.categories[0].lesson_set[0];
		}
      this.choose(this.active.lesson, this.active.category);
    });
  }

	ngOnChanges(changes: SimpleChanges) {
		if ( changes.isOpen.previousValue === true && changes.isOpen.currentValue === false ) {
			this.onComponentClose();
		}
	}
}




// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/lessons/lessons.component.ts